import list from './list'
import icon from '@mui/icons-material/CircleNotificationsOutlined'

const adminConfig = { list, icon };

export default adminConfig;
